<template>
    <table class="mx-auto">
        <thead>
            <tr>
                <th class="">{{change_data.room_id}}</th>
                <th>Thông tin mới</th>
                <th>Thông tin cũ</th>
            </tr>
        </thead>
        <tbody>
            <tr :class="change_data.washing_machine !== change_data.old_data.washing_machine ? 'hightlight-row' : ''">
                <td class="cell-fit font-weight-bold">Máy giặt</td>
                <td class="text-center">{{change_data.washing_machine ? 'Có' : 'Không'}}</td>
                <td class="text-center">{{change_data.old_data.washing_machine ? 'Có' : 'Không'}}</td>
            </tr>
            <tr :class="change_data.air_conditioner !== change_data.old_data.air_conditioner ? 'hightlight-row' : ''">
                <td class="cell-fit font-weight-bold">Máy lạnh</td>
                <td class="text-center">{{change_data.air_conditioner ? 'Có' : 'Không'}}</td>
                <td class="text-center">{{change_data.old_data.air_conditioner ? 'Có' : 'Không'}}</td>
            </tr>
            <template v-for="(customer, index) in change_data.customers">
                <tr
                    :class="customer.is_changed_name ? 'hightlight-row' : ''"
                    :key="`Name ${index + 1}`"
                >
                    <td class="border-top cell-fit font-weight-bold">Tên #{{index + 1}}</td>
                    <td class="border-top text-center">{{customer.name && !customer.is_deleted ? customer.name : "Không"}}</td>
                    <td class="border-top text-center">{{change_data.old_data.customers[index] && change_data.old_data.customers[index].name ? change_data.old_data.customers[index].name : 'Không'}}</td>
                </tr>
                <tr
                    :class="customer.is_changed_phone ? 'hightlight-row' : ''"
                    :key="`Phone ${index + 1}`"
                >
                    <td class="cell-fit font-weight-bold">SDT #{{index + 1}}</td>
                    <td class="text-center">{{customer.phone && !customer.is_deleted ? customer.phone : "Không"}}</td>
                    <td class="text-center">{{change_data.old_data.customers[index] && change_data.old_data.customers[index].phone ? change_data.old_data.customers[index].phone : 'Không'}}</td>
                </tr>
                <tr
                    :class="customer.is_changed_motorbike ? 'hightlight-row' : ''"
                    :key="`Motorbike ${index + 1}`"
                >
                    <td class="cell-fit font-weight-bold">Xe máy #{{index + 1}}</td>
                    <td class="text-center">{{customer.motorbike && !customer.is_deleted ? customer.motorbike : "Không"}}</td>
                    <td class="text-center">{{change_data.old_data.customers[index] && change_data.old_data.customers[index].motorbike ? change_data.old_data.customers[index].motorbike : "Không"}}</td>
                </tr>
                <tr
                    :class="customer.is_changed_bike ? 'hightlight-row' : ''"
                    :key="`Bike ${index + 1}`"
                >
                    <td class="cell-fit font-weight-bold">Xe đạp #{{index + 1}}</td>
                    <td class="text-center">{{customer.bike && !customer.is_deleted ? "Có" : "Không"}}</td>
                    <td class="text-center">{{change_data.old_data.customers[index] && change_data.old_data.customers[index].bike ? "Có" : "Không"}}</td>
                </tr>
            </template>
        </tbody>
    </table>
</template>

<script>
export default {
    name: "change-detail",
    props: {
        change_data: Object
    }
}
</script>

<style scoped>
    table {
        border-collapse: collapse;
        width: 80%;
        max-width: 800px
    }
    th {
        padding: 8px;
        border-bottom: 1px solid #ddd;
    }
    td {
        padding: 6px
    }
    .cell-fit {
        width:1%;
        white-space:nowrap;
    }
    .border-top {
        padding-top: 9px;
        border-top: 1px solid #ddd;
    }
    .hightlight-row {
        background-color: #ddfbe6;
    }
</style>